import { Store } from '../Store';
import {
    addSearchValInStore,
    addRoleValInStore,
    updateVersionAvailInStore,
    setCurrentIndex,
    setAnswersResponse,
    clearAnswersResponse,
    setApiTokens,
    resetStore,
    setLanguage,
    removeAPIData,
    setLanguageList,
    setLoginCredential,
    addZipcodeCountiesInStore
} from './reducer';

export const addSearchValToStore = (searchValue) => Store.dispatch(addSearchValInStore(searchValue));

export const addRoleValToStore = (val) => Store.dispatch(addRoleValInStore(val));

export const updateAvailableToStore = (hasUpdatedVersion) => Store.dispatch(updateVersionAvailInStore(hasUpdatedVersion));

export const updateCurrentIndex = (index) => Store.dispatch(setCurrentIndex(index));

export const updateAnswersResponse = (answers) => Store.dispatch(setAnswersResponse(answers));

export const clearAnswers = (answers) => Store.dispatch(clearAnswersResponse(answers));

export const updateApiTokens = (data) => Store.dispatch(setApiTokens(data));

export const clearStore = () => Store.dispatch(resetStore());

export const updateLanguage = (language) => Store.dispatch(setLanguage(language));

export const removeAPIDataAction = (storeKey) => Store.dispatch(removeAPIData(storeKey));

export const updateLanguageList = (data) => Store.dispatch(setLanguageList(data));

export const updateLoginCred = (data) => Store.dispatch(setLoginCredential(data));

export const addZipcodeCountyListToStore = (data) => Store.dispatch(addZipcodeCountiesInStore(data));
